if (typeof ol !== 'undefined') {
    require('./torque');
}



//////////////////
// WEBPACK FOOTER
// ./~/torque.js/lib/torque/ol/index.js
// module id = 1742
// module chunks = 6